import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

@Component({
  selector: 'app-description',
  templateUrl: './app-description.component.html',
})
export class AppDescriptionComponent implements OnInit {
  public modalRef: BsModalRef;
  public url: string;
  constructor(private modalService: BsModalService, private router: Router) { }

  ngOnInit() {
  }
  openModal(template: TemplateRef<any>) {
    this.url = this.router.url;
    this.modalRef = this.modalService.show(template);
  }
  saveGopY() {

  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-description/app-description.component.ts